import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';

import { logout } from 'store/entities/users/slice';

const initialState = {
  dialog: null,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openDialogAction: (state, action) => ({
      ...state,
      dialog: action.payload,
    }),
    closeDialogAction: (state) => ({
      ...state,
      dialog: null,
    }),
    updateDialogPropsAction: (state, action) => ({
      ...state,
      dialog: {
        ...state.dialog,
        props: {
          ...state.dialog?.props,
          ...action.payload,
        },
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { openDialogAction, closeDialogAction, updateDialogPropsAction } = uiSlice.actions;

export const dialogVariantSelector = createDraftSafeSelector(
  (state) => state[uiSlice.name] || {},
  ({ dialog }) => dialog?.variant || null,
);

export const dialogPropsSelector = createDraftSafeSelector(
  (state) => state[uiSlice.name] || {},
  ({ dialog }) => dialog?.props || {},
);

export const DIALOG_PROPS_PATH = `${uiSlice.name}.dialog.props`;
